/** Placeholder product mark: a calendar with an orange dot. Sits inside `.brand-mark`, which sets its colour. */
export function BrandMark() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
    >
      <path d="M4 9h16M8 3v4M16 3v4" />
      <rect x="4" y="5" width="16" height="16" rx="3" />
      <circle cx="12" cy="15" r="2.2" fill="#ec6b31" stroke="none" />
    </svg>
  )
}
